/* eslint-disable max-len */
import React from 'react';

const CloseIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" {...props}>
    <path
      fill="currentColor"
      d="M11.88 1.09L10.8 0 6 4.848 1.2 0 .12 1.09l4.8 4.85L0 10.91 1.08 12 6 7.03 10.92 12 12 10.91 7.08 5.94z"
    />
  </svg>
);

export default CloseIcon;
